import Work1 from "../../assets/work-1.svg";
import Work2 from "../../assets/work-2.svg";
import Work3 from "../../assets/work-3.svg";
import Work4 from "../../assets/work-4.svg";
import Work5 from "../../assets/work-5.svg";
import Work6 from "../../assets/work-6.svg";

const Menu = [
  {
    id: 1,
    image: Work1,
    title: "Kanbanify",
    category: "ReactJS",
    link: "https://kanbanify.netlify.app/",
  },
  {
    id: 2,
    image: Work2,
    title: "MarkDown ProEditor",
    category: "ReactJS",
    link: "https://markdown-pro-editor.netlify.app/",
  },
  {
    id: 3,
    image: Work3,
    title: "Secure Password Generator",
    category: "ReactJS",
    link: "https://secure-passaword-generator.netlify.app/",
  },
  ,
  {
    id: 4,
    image: Work4,
    title: "ScanPay Genie",
    category: "NextJS",
    link: "https://scan-pay-genie.netlify.app/",
  },
  ,
  {
    id: 5,
    image: Work5,
    title: "Dev Hunter",
    category: "Javascript",
    link: "https://github-dev-hunter.netlify.app/",
  },
  ,
  {
    id: 6,
    image: Work6,
    title: "Rock paper scissors game",
    category: "Javascript",
    link: "https://rps-duel.netlify.app/",
  },
];

export default Menu;
